import React from 'react';
import { LogOut } from 'react-feather';
import { Link } from '@reach/router';

import styles from './Header.module.scss';
import LogoutButton from '../LogoutButton';
import logo from '../../images/logos/boomer.svg';

const Header = ({ user, portalFranchise, portalFranchiseId, portalPage = 'dashboard' }) => {
    return (
        <header className={portalFranchiseId ? `${styles.header} ${styles.portalHeader}` : styles.header}>
            <div className={styles.headerInner}>
                <div  className={styles.headerInnerLeft} >
                    <Link className={styles.headerHomeLink} to={portalFranchiseId ? `/franchise-portal/${portalFranchiseId}` : "/"}>
                        <img src={logo} className={styles.headerLogo} alt='Go Apps Logo' />
                        <p className={styles.headerTitle}>{portalFranchise && portalFranchise.name ? `${portalFranchise.name} Admin` : 'Admin'}</p>
                    </Link>
                    {
                        user && portalFranchiseId ? (
                            <div className={styles.headerLinks}>
                                <Link to={`/franchise-portal/${portalFranchiseId}`} className={portalPage === 'dashboard' ? styles.activeLink : undefined} aria-current={portalPage === 'dashboard' ? 'page' : undefined}>Dashboard</Link>
                                <Link to={`/franchise-portal/${portalFranchiseId}/schools`} className={portalPage === 'schools' ? styles.activeLink : undefined} aria-current={portalPage === 'schools' ? 'page' : undefined}>Schools</Link>
                                <Link to={`/franchise-portal/${portalFranchiseId}/admins`} className={portalPage === 'admins' ? styles.activeLink : undefined} aria-current={portalPage === 'admins' ? 'page' : undefined}>Admin Users</Link>
                                <Link to={`/franchise-portal/${portalFranchiseId}/revenue`} className={portalPage === 'revenue' ? styles.activeLink : undefined} aria-current={portalPage === 'revenue' ? 'page' : undefined}>Revenue</Link>
                                <span>Support</span>
                            </div>
                        ) : user && user.countryAdmin !== 'IND' && (
                            <div className={styles.headerLinks}>
                                <Link to='/dataDashboard'>Reading Data</Link>
                                <Link to='/schools'>Manage Schools</Link>
                                <Link to='/users'>All Admins</Link>
                                <Link to='/franchises'>Franchises</Link>
                            </div>
                        )
                    }
                </div>


                {
                    user && (
                        <LogoutButton classes={styles.headerLogout}>
                            <LogOut />
                        </LogoutButton>

                    )
                }
            </div>
        </header>
    )
}

export default Header;
